module.exports = __webpack_public_path__ + "static/index/img/baikal-207.6cc838b6.jpg";